import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {}

const RenditionDroplet: React.FC<Props> = ({...props}) => {
    return (
        <svg width={20} height={21} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.592 14.81c-3.16 2.968-8.225 2.912-11.313-.125-3.088-3.037-3.03-7.905.13-10.873C4.264 2.068 6.385-.303 8.77.032c1.674.235 3.677 2.652 4.95 3.904 3.088 3.037 3.03 7.905-.13 10.874z"
                fill="#FF7670"
            />
            <path
                d="M13.758 12.767c-1.916 3.084-6.07 4.092-9.28 2.25C1.27 13.176.222 9.182 2.139 6.098c.729-1.175 1.8-2.423 3.004-2.952.936-.412 2.104.315 3.138.34 1.126.026 2.101-.233 3.137.362 3.21 1.841 4.257 5.834 2.341 8.919z"
                fill="#FFC070"
            />
            <path
                d="M12.66 12.499c-1.875 2.436-5.45 2.95-7.985 1.147-2.534-1.802-3.069-5.238-1.194-7.674.883-1.147 2.854.21 4.205-.044 1.518-.285 2.439-2.057 3.78-1.104 2.535 1.803 3.07 5.239 1.194 7.675z"
                fill="#FFF06F"
            />
        </svg>
    );
};

export default RenditionDroplet;
